import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class ActivateBankAccountCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:string|Number, user_id:string|Number): Promise<any> {
    let args = { 
      company_id: company_id,
      user_id: user_id
    }
    try {
      let res = await this.dispatcher.dispatch('activate_bank_account_in_provider.data', args)
      this.frontend.asyncJobState = 'running';
      this.frontend.asyncJobId = res.job_id
    } catch(error) {
      console.error('Error activate bank account', error)
    }
  }
}